import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './styles.css';
import { format } from 'date-fns';
import HeaderLogged from './HeaderLogged';
import Sidebar from './Sidebar';
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

const BatchFileUploadPage = () => {
  const [externalId, setExternalId] = useState('');
  const [configuration, setConfiguration] = useState('');
  const [file, setFile] = useState(null);
  const [intervalId, setIntervalId] = useState(0);
  const [buttonName, setbuttonName] = useState('Enviar');
  const [buttonDisabled, setbuttonDisabled] = useState(false);
  const [buttonHover, setbuttonHover] = useState('pointer');
  const [selectedFile, setSelectedFile] = useState(null);
  const [options, setOptions] = useState([]);
 
  const handleExternalIdChange = (e) => {
    setExternalId(e.target.value);
  };

  const handleConfigurationChange = (selectedOption) => {
    if (selectedOption) {
      setConfiguration(selectedOption.value);
    } else {
      setConfiguration(null);
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    const file = e.target.files[0];

    // Verificar se um arquivo foi selecionado
    if (file) {
      setSelectedFile(file);
    } else {
      setSelectedFile(null);
    }
  };

  const getFileExtension = (fileName) => {
    const parts = fileName.split('.');
    return parts[parts.length - 1].toLowerCase();
  };

  const getFileType = (file) => {
    const extension = getFileExtension(file.name);
    
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif') {
      return 'image';
    } else if (extension === 'pdf') {
      return 'pdf';
    } else {
      return 'unknown';
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      //limpar os dados das outras chamadas
      setbuttonName(`Enviando arquivo...`);
      setbuttonDisabled(true);
      setbuttonHover('not-allowed');
      
      const formData = new FormData();
      formData.append('ExternalID', externalId);
      formData.append('Configuration', configuration);
      formData.append('File', file);

      var response = '';
      
        response = await axios.post(
          process.env.REACT_APP_BASE_URL + '/api/SendBatchData',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: 'Bearer 55c2fad3-45a4-4e29-b9cf-911d7cf6131f',
            }
          }
        );

        for (let key in response) {
          if (response.hasOwnProperty(key)) {
            console.log(`${key}: `, response[key]);
          }
        }
      const idFromFirstApi = response.data.batchID;
      setbuttonName(`Enviando arquivo...`);
      
      callSecondaryApi(idFromFirstApi);
      startSecondaryApiPolling(idFromFirstApi);
    } catch (error) {
      console.error(error);
    }
  };

  const startSecondaryApiPolling = (idparam) => {
    const idIntervalInternal = setInterval(() => callSecondaryApi(idparam), 10000);
    setIntervalId(idIntervalInternal);
  };

  const callSecondaryApi = async (id) => {
    try {

      setbuttonName(`Processando...`);

      const formData = new FormData();

      console.log("Id: " + id)
      formData.append('batchid', id);

      var response = ''
      
      response = await axios.post(
        process.env.REACT_APP_BASE_URL + '/api/ReturnData',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer 55c2fad3-45a4-4e29-b9cf-911d7cf6131f',
          }
        }
      );
      
      for (let key in response) {
        if (response.hasOwnProperty(key)) {
          console.log(`${key}: `, response[key]);
        }
      }

      if (response.data.status !== 'Waiting Process' && response.data.status !== 'Waiting RPA') 
      {
        setbuttonName("Enviar");
        setbuttonDisabled(false);
        setbuttonHover('pointer');
        clearInterval(intervalId);
        clearInterval(document.getElementById('intervalIdHidden').value);
        

      }
      if (response.data.status === 'Processed') 
      {
        clearInterval(intervalId);
        clearInterval(document.getElementById('intervalIdHidden').value);

        window.location.href = `/filelist?batchid=` + response.data.batchID;
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {

    //verificar se o usuário está logado
    if(localStorage.getItem("user")===null)
    {
      window.location.href = "/";
      
    }
    else{

    const data = JSON.parse(localStorage.getItem("user"));

      const fetchData = async () => {
        const requestBody = new FormData();
        requestBody.append('companyID', data.companyID);

        try {
          const response = await fetch(process.env.REACT_APP_BASE_URL + '/api/ReadConfiguration', {
            method: 'POST',
            body: requestBody
          });

          if (!response.ok) {
            throw new Error('Error occurred while fetching data.');
          }

          const data = await response.json();
          setOptions(data);
          console.log(data);
        } catch (error) {
          console.error(error);
        }
      
      };

      fetchData();

  }



    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
    
  }, [intervalId]);

  const getOptions = (options) => {
    return options.map(option => ({
      label: option,
      value: option
    }));
  };

  return (
    <form onSubmit={handleSubmit}>
    
    <div className='container-fluid p-0'>
      <HeaderLogged></HeaderLogged>
      <div className="row showContentMargin">
        <div className="col-3 col-lg-auto col-xxl-2" id='divSidebar'>
          <Sidebar></Sidebar>
        </div>
        <main className="container col-lg-10 col-xxl-9 p-4" id='divContent'>
            <div className="row">
              <div className="col-md-6">
                <label htmlFor="externalId" className="fs-5">Id Externo:</label>
                <input
                      type="text"
                      id="externalId"
                      className="form-control"
                      value={externalId}
                      onChange={handleExternalIdChange}
                      required
                    />

                <label htmlFor="configuration" className="fs-5 mt-4">Configuração:</label>
                <CreatableSelect
                  options={getOptions(options)}
                  id="configuration"
                  onChange={handleConfigurationChange} required/>

                  {/* <option defaultValue>Selecione uma opção</option>
                  {options.map(option => (
                    <option key={option} value={option}>{option}</option>
                  ))} */}
                <label htmlFor="file" className="fs-5 mt-4">Arquivo:</label>
                <input
                      type="file"
                      id="file"
                      className="form-control"
                      onChange={handleFileChange}
                      accept=".zip"
                      required
                    />
              </div>

              <input type="hidden" name="intervalIdHidden" id ="intervalIdHidden" value={intervalId} /> 

              <div className="col-md-12 text-center mt-4">
              {buttonDisabled ? (
                  <button type="submit" disabled={buttonDisabled} className="btn btn-success btn-lg">
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> {buttonName}
                  </button>
                ) : (
                  <button type="submit" disabled={buttonDisabled} className="btn btn-success btn-lg">
                     {buttonName}
                  </button>
                )}
              </div>

              <hr className="col-md-12 mt-4"/>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              
            </div>
            
        </main>
      </div>
    </div>

  </form>
  );
};

export default BatchFileUploadPage; 